
import {View} from 'backbone';
import constants from 'Constants.js'


class BaseTableView2 extends View {


    get gridEl() {
        return this._gridEl;
    }

    set gridEl(el) {
        this._gridEl = el;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set(propName, propVal);
    }


    itemRemove() {
        var gridData2 = this.model.get('gridData2');
        var rowid2 = this.model.get('rowid2');

        this.model.set(gridData2.splice(rowid2, 1));

    }


    itemUp() {
        var gridData2 = this.model.get('gridData2');
        var rowid2 = this.model.get('rowid2');

        if (rowid2 > 0) {
            gridData2[rowid2] = gridData2.splice((rowid2 - 1), 1, gridData2[rowid2])[0];
            this.model.set('rowid2', rowid2 - 1);
            this.model.set('gridData2', gridData2);
            this.render();
        }

    }


    itemDown() {
        var gridData2 = this.model.get('gridData2');
        var rowid2 = this.model.get('rowid2');

        if (rowid2 < ( gridData2.length - 1)) {
            gridData2[rowid2] = gridData2.splice((rowid2 + 1), 1, gridData2[rowid2])[0];
            this.model.set('rowid2', rowid2 + 1);
            this.model.set('gridData2', gridData2);
            console.log(gridData2);
            this.render();
        }
    }


    itemCheck(e){

        console.log('itemCheck');
        var i = $(e.currentTarget).closest('tr').index()-1;
        var gridData = this.model.get('gridData');

        gridData.forEach(function(value, index) {
            gridData[index].selected = '';
        });// reset out all

        if( e.currentTarget.checked ){
            gridData[i].selected = 'selected';
        }

        this.model.set('gridData', gridData, {silent: true});
        this.model.trigger('change');
        this.render();
    }


    saveCell(rowid2, cellname, value) {
        console.log('afterSaveCell ' + rowid2);
        console.log(cellname);
        var gridData2 = this.model.get('gridData2');
        gridData2[rowid2][cellname] = value;
        this.model.set('gridData2', gridData2, {silent: true});
        this.model.trigger('change');
        this.render();
    }

    setRow(rowid2) {
        this.model.set({
            rowid2: rowid2
        }, {silent: true});
    }

    onCellSelect(rowid, iCol, cellcontent, e) {
        return;
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid() {
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function (index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    onRender() {
        return;
    }

    afterRender() {
        return;
    }

    render() {
        console.log('render BaseTableView2');
        this.onRender();
        var gridData2 = this.model.get('gridData2');

        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        $(self._gridEl).jqGrid({
            datatype: "local",
            autowidth: true, 
            shrinkToFit: true,
            altRows: true,
            cellEdit: true,
            cellsubmit: 'clientArray',
            onCellSelect: function (rowid, iCol, cellcontent, e) {
                self.onCellSelect(rowid, iCol, cellcontent, e);
            },
            gridComplete: function () {
                $("tr.jqgrow:odd").css("background", "#DDDDDC");
            },

            //jsonReader : {root: this.model.get('rows') },
            colNames: self.model.get('colNames2'),
            colModel: self.model.get('colModel2'),
            beforeSelectRow: function (rowid2) {
                self.setRow(rowid2);
            },
            afterSaveCell: function (rowid2, cellname, value) {
                self.saveCell(rowid2, cellname, value);
            }, 
            resizeStop: function(width, index) {
                let columns = $(self._gridEl).jqGrid ('getGridParam', 'colModel');
                let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                if ($("#gbox_propMainTable2").width() < colWidth) {
                    $(self._gridEl).closest('.ui-jqgrid-bdiv')
                            .css('overflow', '')
                            .addClass('format-table-overflow-shown');
                }
            }
        });
        
        // Clearing Default Values.
        $(self.gridEl).jqGrid('clearGridData');
        
        gridData2.forEach(function (value, index) {
            $(self._gridEl).addRowData(index, value);
        });

        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        return this;
    }

}

export default BaseTableView2;
